export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            多端观影
          </h2>
        </div>
        <div className="bg-gradient-to-br from-background-950 to-background-900 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-14">
              <h3 className="font-heading text-2xl md:text-3xl font-extrabold text-white">
                随时随地 畅享高清影视
              </h3>
              <p className="text-white/70 text-sm md:text-base mt-4 leading-relaxed max-w-md">
                白云视频全面适配<strong className="text-white/90">手机、平板、电脑</strong>等多种设备。
                无论你是在通勤路上、午休间隙还是家中放松，打开浏览器即可畅享两万部高清影视资源。
                智能适配屏幕尺寸，小屏大屏都清晰。
              </p>
              <div className="flex flex-wrap gap-3 mt-6">
                <span className="whitespace-nowrap inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-white/10 text-white text-sm font-medium">
                  <i className="ri-smartphone-line text-lg"></i>
                  手机观影
                </span>
                <span className="whitespace-nowrap inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-white/10 text-white text-sm font-medium">
                  <i className="ri-tablet-line text-lg"></i>
                  平板观影
                </span>
                <span className="whitespace-nowrap inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-white/10 text-white text-sm font-medium">
                  <i className="ri-computer-line text-lg"></i>
                  电脑观影
                </span>
              </div>
            </div>
            <div className="flex-1 w-full lg:w-auto">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20tablet%20and%20laptop%20displaying%20cinematic%20movie%20content%20side%20by%20side%2C%20dark%20elegant%20background%2C%20warm%20screen%20glow%2C%20professional%20product%20photography%2C%20clean%20minimalist%20composition%2C%20soft%20ambient%20lighting%2C%20no%20text&width=700&height=500&seq=app-section-visual&orientation=landscape"
                alt="白云视频多端观影"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}